export default __webpack_public_path__ + "static/media/2b85b2d4da772f9c.4ca1000a55031b61d599e3422e976162.svg";